<template>
	<OfferStatTile>
		<template v-slot:icon>
			<div class="d-flex align-center justify-center mr-2">
        <span v-if="likes === 0" class="text-success likes-typography">NEW</span>
        <LikedIcon v-else-if="likes > 50" :color="'#A3E21D'" class="icon-size"/>
				<DislikedIcon v-else :color="'red'" class="icon-size" />
			</div>
      <div v-if="likes !== 0" :class="[likes > 50 ? 'text-success' : 'text-danger', 'likes-typography']">{{ likes }}%</div>
		</template>
		<template v-slot:title>Popularity Score</template>
	</OfferStatTile>
</template>



<script setup lang="ts">

import LikedIcon from "@/icons/Liked.vue";
import OfferStatTile from './Offer-Stat-Tile.vue';
import DislikedIcon from "@/icons/DislikedIcon.vue";

defineProps<{
	likes: number
}>();

</script>



<style scoped lang="scss">

.icon-size {
	width: 26px;
	height: 26px;
}

.text-success {
	color: vars.get-map-value(vars.$text-color, rating, up) !important;
}

.text-danger {
	color: vars.get-map-value(vars.$text-color, rating, down) !important;
}

</style>